import Vue from 'vue'
import Vuex from 'vuex'
import Logger from '@/services/Logger'
import * as auth from '@/store/modules/auth'
import * as users from '@/store/modules/users'
import * as snackbar from '@/store/modules/snackbar'
import * as messaging from '@/store/modules/messaging'
import * as status from '@/store/modules/status'
import * as settings from '@/store/modules/settings'

Vue.use(Vuex)

const GlobalStateLocalStorageKey = 'globalstate'

const persistedState = {
  previousRoute: null
}

function persistState () {
  try {
    localStorage.setItem(
      GlobalStateLocalStorageKey,
      JSON.stringify(persistedState)
    )
  } catch (error) {
    Logger.error(`Persisting the global state failed: ${error}`)
  }
}

function setPersistedStateProperty (state, propertyName, value) {
  persistedState[propertyName] = value
  state[propertyName] = value
  persistState()
}

export default new Vuex.Store({
  modules: {
    auth,
    users,
    snackbar,
    messaging,
    status,
    settings
  },
  state: {
    ...persistedState
  },
  mutations: {
    SET_PREVIOUS_ROUTE (state, previousRoute) {
      if (
        persistedState.previousRoute == null ||
        previousRoute.fullPath !== persistedState.previousRoute.fullPath
      ) {
        setPersistedStateProperty(state, 'previousRoute', {
          name: previousRoute.name,
          params: previousRoute.params,
          props: previousRoute.props,
          fullPath: previousRoute.fullPath
        })
      }
    }
  }
})
